import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

/**
 * Thin wrapper around Sonner that ships our dark-theme defaults. The
 * <ToastViewport /> below should be mounted exactly once at the app root
 * (see providers/ToastProvider.tsx).
 */
export function ToastViewport() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      theme="dark"
      toastOptions={{
        classNames: {
          toast:
            "border border-[var(--surface-line-strong)] bg-[var(--bg-elev)] text-text-strong",
          description: "text-text-mute",
        },
      }}
    />
  );
}

export const toast = sonnerToast;
